/* COS Cart Modules - Timer, Free Shipping, Trust Swiper, Discount Code */
/* All modules wrapped in re-callable functions so they re-init after cart drawer re-render */

var CosCartModules = (function() {
  var timerInterval = null;

  /* ═══ Timer ═══ */
  function initTimer() {
    var timerModule = document.querySelector('.drawer__module--timer');
    if (!timerModule) return;

    var timerEl = timerModule.querySelector('.drawer__module--timer-time');
    if (!timerEl) return;

    // Ne lancer le minuteur que si le panier contient des articles (rien à
    // « réserver » sur un panier vide).
    if (!document.querySelector('cart-drawer-items .cart-item, cart-items .cart-item, .cart-item')) {
      if (timerInterval) clearInterval(timerInterval);
      return;
    }

    var time;
    var storageKey = 'cosDrawerTimer';

    var cosDur = parseInt(timerModule.dataset.duration, 10) * 60 || 600;
    var cosStored = parseInt(localStorage.getItem(storageKey), 10);
    if (cosStored > 0 && cosStored <= cosDur) {
      time = cosStored;
    } else {
      time = cosDur;
      localStorage.setItem(storageKey, time);
    }

    // Reset timer when cart changes if configured
    if (timerModule.dataset.resetOnAdd === 'true') {
      document.addEventListener('cart:updated', function() {
        time = parseInt(timerModule.dataset.duration, 10) * 60;
        localStorage.setItem(storageKey, time);
      });
    }

    if (timerInterval) clearInterval(timerInterval);

    var tick = function() {
      if (time <= 0) {
        // Minuteur visuel : on RELANCE le décompte depuis la durée configurée,
        // toujours sans recharger la page ni vider le panier.
        time = parseInt(timerModule.dataset.duration, 10) * 60 || 600;
      }
      var minutes = Math.floor(time / 60);
      var seconds = time % 60;
      timerEl.textContent = minutes + ':' + seconds.toString().padStart(2, '0');
      localStorage.setItem(storageKey, time--);
    };

    tick();
    timerInterval = setInterval(tick, 1000);
  }

  /* ═══ Free Shipping ═══ */
  function initFreeShipping() {
    var module = document.querySelector('.drawer__module--free_shipping');
    if (!module) return;

    var before = module.querySelector('.free-shipping__left-amount');
    var after = module.querySelector('.free-shipping__success');
    var amountEl = module.querySelector('.free-shipping__amount');
    var drag = module.querySelector('.free-shipping__drag');

    if (!amountEl || !drag) return;

    var totalPrice = parseFloat(amountEl.dataset.totalPrice || 0) / 100;
    var target = parseFloat(module.dataset.target || 0);

    var locale = document.documentElement.lang || 'fr-FR';
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'EUR';

    var remaining = target - totalPrice;

    if (remaining > 0) {
      var formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(remaining);

      amountEl.textContent = formatted;
      if (before) before.classList.remove('hidden');
      if (after) after.classList.add('hidden');
      drag.style.width = ((totalPrice * 100) / target) + '%';
    } else {
      if (after) after.classList.remove('hidden');
      if (before) before.classList.add('hidden');
      drag.style.width = '100%';
    }
  }

  /* ═══ Trust Swiper (carousel) ═══ */
  function initTrustSwiper() {
    var trustSwiper = document.querySelector('#drawer-trust__swiper');
    if (!trustSwiper || typeof Swiper === 'undefined') return;

    new Swiper('#drawer-trust__swiper', {
      autoplay: { delay: 2500, disableOnInteraction: false },
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        prevEl: '.button-prev-drawer-trust__swiper',
        nextEl: '.button-next-drawer-trust__swiper',
      },
    });
  }

  /* ═══ Discount Code ═══ */
  function initDiscountCode() {
    var btn = document.querySelector('.cart__discount-btn');
    if (!btn) return;

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var inputId = btn.dataset.input || 'cartDrawerDiscountCode';
      var input = document.getElementById(inputId);
      if (input && input.value.trim()) {
        window.location.href = '/checkout?discount=' + encodeURIComponent(input.value.trim());
      }
    });
  }

  /* ═══ Protection Toggle ═══ */
  function initProtection() {
    var toggleBtn = document.querySelector('.drawer__protection--toggle');
    if (!toggleBtn) return;

    toggleBtn.addEventListener('click', function() {
      var variantId = toggleBtn.dataset.protectionVariant;
      var isActive = toggleBtn.dataset.protectionActive === 'true';

      if (isActive) {
        // Remove protection from cart
        var index = parseInt(toggleBtn.dataset.protectionIndex, 10);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: index, quantity: 0 })
        }).then(function() { window.location.reload(); });
      } else {
        // Add protection to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        }).then(function() { window.location.reload(); });
      }
    });
  }

  /* ═══ Delivery Estimation ═══ */
  function initDeliveryEstimation() {
    var estimations = document.querySelectorAll('delivery-estimation');
    estimations.forEach(function(el) {
      var readyDays = parseInt(el.dataset.ready, 10) || 2;
      var deliveredDays = parseInt(el.dataset.delivered, 10) || 8;
      var format = el.dataset.format || 'dd/MM';

      var now = new Date();

      function formatDate(date) {
        var d = date.getDate().toString().padStart(2, '0');
        var m = (date.getMonth() + 1).toString().padStart(2, '0');
        return format === 'dd/MM' ? d + '/' + m : m + '/' + d;
      }

      function addBusinessDays(start, days) {
        var result = new Date(start);
        var added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          if (result.getDay() !== 0 && result.getDay() !== 6) added++;
        }
        return result;
      }

      var todayEl = el.querySelector('.delivery__date.today');
      var readyEl = el.querySelector('.delivery__date.ready');
      var deliveredEl = el.querySelector('.delivery__date.delivered');

      if (todayEl) todayEl.textContent = formatDate(now);
      if (readyEl) readyEl.textContent = formatDate(addBusinessDays(now, readyDays));
      if (deliveredEl) deliveredEl.textContent = formatDate(addBusinessDays(now, deliveredDays));
    });
  }

  /* ═══ Marketing Text ═══ */
  function initMarketingText() {
    // Marketing text is static HTML, no JS init needed
    // but we ensure visibility after re-render
    var marketingModules = document.querySelectorAll('.drawer__module--marketing');
    marketingModules.forEach(function(mod) {
      mod.style.display = '';
    });
  }

  /* ═══ Init All ═══ */
  function initGiftNameFit() {
    function fit() {
      document.querySelectorAll('cart-drawer .cart-item--gift .cart-item__name').forEach(function (el) {
        el.style.whiteSpace = 'nowrap';
        el.style.fontSize = '';
        if (el.clientWidth < 10) return; // tiroir pas encore visible
        var size = parseFloat(getComputedStyle(el).fontSize) || 12;
        var guard = 0;
        while (el.scrollWidth > el.clientWidth + 1 && size > 8 && guard < 40) {
          size -= 0.5;
          el.style.fontSize = size + 'px';
          guard++;
        }
      });
    }
    fit();
    if (!window.__cosGiftFitHooked) {
      window.__cosGiftFitHooked = true;
      var t;
      var schedule = function () { clearTimeout(t); t = setTimeout(fit, 60); };
      var drawer = document.querySelector('cart-drawer');
      if (drawer && window.MutationObserver) {
        new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
      }
      window.addEventListener('resize', schedule);
    }
  }

  function initAll() {
    initTimer();
    initFreeShipping();
    initTrustSwiper();
    initDiscountCode();
    initProtection();
    initDeliveryEstimation();
    initMarketingText();
    initGiftNameFit();
  }

  // Run on page load
  initAll();

  // Expose for re-init after cart drawer re-render
  return { init: initAll };
})();


/* novak — watchdog anti-blocage panier */
(function () {
  if (window.__cosUpdWatch) return;
  window.__cosUpdWatch = true;
  var seen = new WeakMap();
  setInterval(function () {
    var els = document.querySelectorAll('cart-drawer .is-updating');
    var now = Date.now();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var t = seen.get(el);
      if (!t) { seen.set(el, now); continue; }
      if (now - t > 1000) { el.classList.remove('is-updating'); seen.delete(el); }
    }
  }, 300);
})();


/* ===== Novack — refonte panier (haut B + bas A) — nkCartRedesign ===== */
(function () {
  function stripEmoji(p) {
    if (!p) return;
    p.childNodes.forEach(function (n) {
      if (n.nodeType === 3) {
        var c = n.textContent.replace(/^[\s\u231A-\u231B\u23F0-\u23F3\u2600-\u27BF\u2B00-\u2BFF\uFE0F\u200D\uD83C-\uDBFF\uDC00-\uDFFF]+/, '');
        if (c !== n.textContent) n.textContent = c;
      }
    });
  }
  function redesign() {
    var drawer = document.querySelector('.cart-drawer, cart-drawer');
    if (!drawer) return;
    // Textes personnalisables (réglages thème, via #nk-cart-config) + valeurs par défaut.
    var cfg = document.getElementById('nk-cart-config');
    var delivText = (cfg && cfg.dataset.delivText) || 'Livraison suivie · reçu estimé le';
    var saveText = (cfg && cfg.dataset.saveText) || 'Tu économises';
    // HAUT — timer : retire l'émoji + barre qui se vide
    var t = drawer.querySelector('.drawer__module--timer');
    if (t) {
      stripEmoji(t.querySelector('.timer__text'));
      if (!t.querySelector('.nk-timer-track')) {
        var total = (parseInt(t.dataset.duration, 10) || 10) * 60;
        var bar = document.createElement('div'); bar.className = 'nk-timer-track'; bar.innerHTML = '<i></i>';
        t.appendChild(bar);
        var fill = bar.firstChild;
        var upd = function () {
          var el = t.querySelector('.drawer__module--timer-time'); if (!el) return;
          var m = el.textContent.trim().split(':');
          var rem = (parseInt(m[0]) || 0) * 60 + (parseInt(m[1]) || 0);
          fill.style.width = Math.max(0, Math.min(100, rem / total * 100)) + '%';
        };
        upd(); if (t.__nkbar) clearInterval(t.__nkbar); t.__nkbar = setInterval(upd, 1000);
      }
    }
    // Livraison : le module frise est masqué en CSS (.drawer__module--delivery-estimation),
    // on lit seulement la date livrée pour la pastille du bas.
    var ddEl = drawer.querySelector('.delivery__date.delivered');
    var delivDate = ddEl ? ddEl.textContent.trim() : '';
    // BAS — masquer le détail totaux
    var totals = drawer.querySelector('.cart-drawer__footer');
    if (totals && totals.style.display !== 'none') totals.style.display = 'none';
    var totEl = drawer.querySelector('.totals--total .totals__subtotal-value');
    var total = totEl ? totEl.textContent.trim().replace(' EUR', '') : '';
    var saveEl = drawer.querySelector('.totals.savings .savings__amount');
    var save = saveEl ? saveEl.textContent.trim().replace(/^-/, '') : '';
    // BAS — pastille livraison + « Tu économises … » au-dessus du bouton
    var ctas = drawer.querySelector('.cart__ctas');
    if (ctas && ctas.parentNode) {
      var holder = ctas.parentNode;
      // « Tu économises »
      var saveLine = holder.querySelector('.nk-save');
      if (save) {
        var stxt = saveText + ' ' + save;
        if (!saveLine) { saveLine = document.createElement('div'); saveLine.className = 'nk-save'; }
        if (saveLine.textContent !== stxt) saveLine.textContent = stxt;
      } else if (saveLine) { saveLine.remove(); saveLine = null; }
      // Pastille livraison (au-dessus de « Tu économises »)
      var pill = holder.querySelector('.nk-deliv');
      if (delivDate) {
        var ph = delivText + ' <span class="d">' + delivDate + '</span>';
        if (!pill) { pill = document.createElement('div'); pill.className = 'nk-deliv'; }
        if (pill.innerHTML !== ph) pill.innerHTML = ph;
      } else if (pill) { pill.remove(); pill = null; }
      // Ordre : pastille → économies → bouton
      if (saveLine && saveLine.nextSibling !== ctas) holder.insertBefore(saveLine, ctas);
      if (pill) { var ref = saveLine || ctas; if (pill.nextSibling !== ref) holder.insertBefore(pill, ref); }
    }
    // BAS — total sur le bouton
    var btn = drawer.querySelector('.cart__checkout-button');
    if (btn && total) {
      var tot = btn.querySelector('.nk-tot');
      if (!tot) {
        if (!btn.dataset.nkBase) btn.dataset.nkBase = (btn.textContent || '').trim();
        btn.innerHTML = (btn.dataset.nkBase || '') + ' <span class="nk-tot"></span>';
        tot = btn.querySelector('.nk-tot');
      }
      if (tot.textContent !== total) tot.textContent = total;
    }
  }
  // Animation fluide au clic « Passer la commande »
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cart__checkout-button');
    if (b) b.classList.add('nk-loading');
  }, true);
  function boot() {
    redesign();
    var d = document.querySelector('.cart-drawer, cart-drawer');
    if (d && !d.__nkObs) {
      d.__nkObs = new MutationObserver(function () { window.requestAnimationFrame(redesign); });
      d.__nkObs.observe(d, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  setInterval(redesign, 1500);
})();


/* ===== Novack — quantité panier : clics groupés, jamais bloqués — nkQtyDebounce ===== */
(function () {
  var timers = new WeakMap();
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.quantity__button');
    if (!btn) return;
    if (!btn.closest('.cart-drawer, cart-drawer')) return; // tiroir panier uniquement
    var qi = btn.closest('quantity-input, .quantity');
    var input = qi && qi.querySelector('.quantity__input, input');
    if (!input) return;
    // On gère nous-mêmes : on bloque le handler natif (qui enverrait tout de suite).
    e.preventDefault();
    e.stopImmediatePropagation();
    var step = parseInt(input.getAttribute('step') || '1', 10) || 1;
    var min = parseInt(input.getAttribute('min') || '0', 10); if (isNaN(min)) min = 0;
    var cur = parseInt(input.value || '0', 10) || 0;
    var next = cur + (btn.getAttribute('name') === 'plus' ? 1 : -1) * step;
    if (next < min) next = min;
    if (next === cur) return;
    input.value = next; // incrément local immédiat (visuel)
    var t = timers.get(input);
    if (t) clearTimeout(t);
    timers.set(input, setTimeout(function () {
      // Un seul envoi serveur avec la quantité finale (laisse le thème re-rendre).
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, 480));
  }, true);
})();
